<template>
  <div>
    <bxs-bottom-sheets
      v-model="visible"
      class="interest_table_column"
      title="筛选"
      :height="scene === 'normal' ? 'large' : '50%'"
      :prevent-scroll-through="true"
    >
      <div class="content">
        <template v-for="item in interestItems">
          <dl :key="item.key">
            <dt>
              <p>{{ item.name }}</p>
              <p
                v-if="item.actionBtnTx"
                @click="onClickRightButton(item)"
              >
                <span>{{ item.actionBtnTx }}</span>
                <i class="iconfont icon-arrows_right" />
              </p>
            </dt>
            <dd
              v-for="o in item.options.filter(e => !e.hiddenFlag)"
              :key="item.key + (o.index || o.value)"
              :class="{
                active: isActiveOption(item, o)
              }"
              :data-stat-id="item.stat"
              :data-stat-ep="JSON.stringify({
                key: o.value,
                state: item.key === 'displayFields' ? values[item.key] && values[item.key].includes(o.value) ? 'qx' : 'tj' : undefined
              })"
              @click="onClickOption(item, o)"
              v-html="o.description"
            />
          </dl>
        </template>
      </div>
      <div slot="footer" class="footer">
        <div class="footer_wrapper">
          <span @click="confirm">确定</span>
        </div>
      </div>
    </bxs-bottom-sheets>

    <bxs-bottom-sheets
      v-model="addAndTakePopupConfig.visible"
      :title="addAndTakePopupConfig.title"
      height="middle"
      :prevent-scroll-through="true"
    >
      <AddAndTake
        v-if="addAndTakePopupConfig.visible"
        ref="AddAndTake"
        :type="addAndTakePopupConfig.type"
        :result-data="addAndTakePopupConfig.resultData"
        :params="addAndTakePopupConfig.params"
        @confirm="addAndTakeConfirm"
      />
    </bxs-bottom-sheets>

    <InterestFormRate
      v-model="ratePopupConfig.visible"
      :form-data="formData"
      :has-custom-rate="ratePopupConfig.hasCustomRate"
      :previous-rate="ratePopupConfig.cachePreviousRate"
      @update="rateConfirm"
    />
  </div>
</template>
<script>
import { get as _get, cloneDeep } from 'lodash'
import { BottomSheets } from 'bxs-ui-vue'
import { AddAndTake } from 'bxs-tools-ui'
import InterestFormRate from './interest-form-rate.vue'

export default {
  components: {
    [BottomSheets.name]: BottomSheets,
    AddAndTake,
    InterestFormRate
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    interestFieldOptions: {
      type: Array,
      default: () => ([])
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    params: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      scene: 'normal', // normal | export
      values: null,
      backupFormData: null,
      addAndTakePopupConfig: this.initAddAndTakePopupConfig(),
      ratePopupConfig: this.initRatePopupConfig(),
      isClickConfirm: false
    }
  },
  computed: {
    interestItems () {
      const items = cloneDeep(this.interestFieldOptions)
      if (!items) {
        return []
      }
      items.forEach(item => {
        if (item.key === 'rate') {
          if (item.options) {
            item.options = item.options.filter(o => o.index !== -1)
          }
        }
      })
      return items
    },
    visible: {
      get () {
        if (this.value) {
          this.backupFormData = cloneDeep(this.formData)
        }
        return this.value
      },
      set (v) {
        if (v) {
          return
        }
        const { backupFormData, isClickConfirm } = this
        let values = {
          isShowFieldPopup: false
        }
        if (!isClickConfirm) {
          values = cloneDeep({
            ...backupFormData.formValues,
            addAndTakeData: backupFormData.addAndTakeData,
            customRate: backupFormData.customRate,
            drawData: backupFormData.drawData,
            isShowFieldPopup: false
          })
        }
        this.scene = 'normal'
        this.isClickConfirm = false
        this.$emit('confirm', values)
      }
    }
  },
  watch: {
    'formData.formValues': {
      deep: true,
      immediate: true,
      handler (v) {
        this.values = cloneDeep(v)
      }
    },
    'addAndTakePopupConfig.visible': {
      immediate: true,
      handler (v) {
        if (v) {
          return
        }
        const _ref = _get(this.$refs, 'AddAndTake')
        const _subName = _get(this.$refs, 'AddAndTake.subName', '')
        if (_subName === 'Form') {
          this.addAndTakePopupConfig.visible = true;
          _ref.goToTable();
        }
      }
    }
  },
  methods: {
    initAddAndTakePopupConfig() {
      return {
        visible: false,
        title: '',
        type: '',
        resultData: null,
        params: null
      }
    },
    initRatePopupConfig() {
      return {
        visible: false,
        hasCustomRate: null,
        cachePreviousRate: null
      }
    },
    isActiveOption (item, o) {
      const { formData, values } = this
      let bool = values[item.key] === o.value
      if (values[item.key] && values[item.key].constructor === Array) {
        bool = values[item.key].includes(o.value)
      }
      if (['rate'].includes(item.key)) {
        const { rateIndex } = values
        bool = o.index === rateIndex || (rateIndex === -1 && Math.abs(formData.customRate - o.value) < 1e-5)
      }
      if (['addAndTakeData'].includes(item.key)) {
        bool = values.addAndTakeFlag === o.value
      }
      if (['drawData'].includes(item.key)) {
        bool = values.drawFlag === o.value
      }
      return bool
    },
    onClickRightButton (item) {
      const { formData, values, params } = this
      if (item.key === 'rate') {
        this.ratePopupConfig = {
          visible: true,
          hasCustomRate: item.hasCustomRate,
          cachePreviousRate: formData.formValues.rate ? Number(formData.formValues.rate) : null
        }
        return
      }
      if (['addAndTakeData', 'drawData'].includes(item.key)) {
        const type = item.key === 'drawData' ? 'reduceBaof' : formData.addAndTakeData.accountPart
        const insuranceKey = type === 'reduceBaof' ? formData.drawInsuranceId : formData.accountInsuranceId
        const accountData = type === 'reduceBaof' ? {
          accountPart: 'take',
          addAndTakeData: formData.drawData || []
        } : formData.addAndTakeData
        this.addAndTakePopupConfig = {
          visible: true,
          title: item.name,
          type,
          resultData: {
            uuid: params.uuid,
            insuredAge: params.insuredAge,
            accountData
          },
          params: {
            productKey: formData.productId,
            insuranceKey,
            bonus: values.bonus,
            takeType: values.takeType,
            rate: values.rateIndex === -1 ? formData.customRate : values.rate,
          }
        }
      }
    },
    onClickOption (item, o) {
      const { scene, values } = this
      if (['drawData'].includes(item.key)) {
        values.drawFlag = o.value
        return
      }
      if (['addAndTakeData'].includes(item.key)) {
        values.addAndTakeFlag = o.value
        return
      }
      if (values[item.key] && values[item.key].constructor === Array) {
        const set = new Set(values[item.key] || [])
        if (set.has(o.value)) {
          if (set.size > 1) {
            set.delete(o.value)
          }
        } else {
          set.add(o.value)
        }
        values[item.key] = [...set]
        if (scene === 'export') {
          if (item.key === 'displayFields') {
            this.$emit('confirm', cloneDeep(values))
          }
        }
        return
      }

      if (['rate'].includes(item.key)) {
        if (o.index === -1) {
          return
        }
        values.rateIndex = o.index
      }
      values[item.key] = o.value
    },
    rateConfirm (data) {
      if (!data) {
        return
      }
      this.$emit('confirm', {
        ...data,
        isShowFieldPopup: true
      })
      this.ratePopupConfig = this.initRatePopupConfig()
    },
    addAndTakeConfirm(data) {
      if (!data) {
        return
      }
      this.$emit('addAndTakeConfirm', {
        ...data,
        type: _get(this, 'addAndTakePopupConfig.type')
      })
      this.addAndTakePopupConfig = this.initAddAndTakePopupConfig()
    },
    confirm () {
      this.isClickConfirm = true
      this.visible = false
      this.$emit('confirm', cloneDeep({
        ...this.values,
        isShowFieldPopup: false
      }))
      this.$emit('save', 1)
    }
  }
}
</script>
<style>
@import './interest-show-fields.css';
</style>
